export default __webpack_public_path__ + "static/media/mode-2005.3d1f0548.svg";